import './popup-title.css';

function PopupTitle({ children }) {
  return <h3 className="popup-title">{children}</h3>;
}

export default PopupTitle;
